import React from 'react';

import '../App.css';

class LandingGamePreview extends React.Component
{
	render()
	{
		var game = this.props.game;

		return (
			<a
				href={game.gameLink}
				target="_blank"
				className='landing-game-preview'
			>

				<img
					className='landing-game-preview-img'
					src={require("../images/game_thumbnails/" + game.gameThumbnailURL)}
				/>

				<div className='landing-game-name-container'>

					{game.gameName}

				</div>

			</a>
		);
	}
}

export default LandingGamePreview;